<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span
      class="fa fa-calendar-o"></span>{{ 'bikeshop.shop_rides.event_schedule' | translate }}</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>

  <div class="calendar-container">
    <div class="content">
      <full-calendar #calendar
                     schedulerLicenseKey="0984855613-fcs-1539348025"
                     ignoreTimezone="false"
                     [nowIndicator]="false"
                     timeZone="local"
                     defaultView="Week"
                     [locales]="[ 'enLocale', 'esLocale' ]"
                     [header]="{
                  right: 'prev, next, today, CreateAnEvent',
                  center: 'title',
                  left: headerView
                }"
                     [views]="{
                  Day:{
                    type:'timelineDay',
                    titleFormat : {day: 'numeric', month: 'short', year:'numeric', weekday:'short'},
                    slotLabelInterval: { minutes: 60 },
                    slotDuration: { minutes: 15 },
                    scrollTime:{Duration:'00:00:00'}
                  },
                  Week:{
                    type:'timelineWeek',
                    titleFormat : {day: 'numeric', month: 'short', year:'numeric', weekday:'short'},
                    slotLabelInterval: { days: 1 },
                    slotDuration: { days: 1 },
                    scrollTime:{Duration:'00:00:00'}
                  }
                }"
                     [customButtons]="customButtons"
                     [buttonText]="calendarButtonText"
                     [navLinks]="false"
                     [rerenderDelay]="500"
                     [showNonCurrentDates]="true"
                     [plugins]="calendarPlugins"
                     [weekends]="calendarWeekends"
                     [minTime]="minTime"
                     [maxTime]="maxTime"
                     [eventLimit]="true"
                     [allDaySlot]="false"
                     [selectable]="false"
                     [editable]="false"
                     [contentHeight]="contentHeight"
                     (eventRender)="renderEvent($event)"
                     (dateClick)="dateClicked($event)"
                     (eventClick)="scheduleClicked($event)"
                     (eventDrop)="scheduleMoved($event)"
                     (eventResize)="scheduleDurationChanged($event)">
      </full-calendar>
      <!--            todo dcorbett fix calendar-->
    </div>

    <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>

  </div>
  <div class="footer">
    <div>{{'bikeshop.shop_rides.past_rides' | translate}}</div>
    <!-- <div>{{'bikeshop.shop_rides.private_rides' | translate}}</div>
    <div>{{'bikeshop.shop_rides.public_rides' | translate}}</div> -->
    <div>{{'bikeshop.shop_rides.inactive_rides' | translate}}</div>
  </div>

  <p-sidebar #NavSideBar [(visible)]="showRide" position="right"
             [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}"
             (onHide)="calendarApi.refetchEvents(); NavSideBar.destroyModal()">
    <div *ngIf="showRide">
      <app-create-edit-ride [rideID]="selectedRideID" (close)="showRide=false"></app-create-edit-ride>
    </div>
  </p-sidebar>
</div>
